import React from 'react';

type Props = {
  condition: boolean;
  wrapper: (content: React.ReactNode) => JSX.Element
  children: React.ReactNode
}

const ConditionalWrapper: React.FC<Props> = ({ condition, wrapper, children }) => {
  if (condition) {
    return wrapper(children);
  }
  return <>{children}</>;
};

export default ConditionalWrapper;
